<template>
  <div>
    <div class="container_wrap">
      <!-- 图片是否显示  在这里判断              v-if="specialTagName != ''》》》》可删 -->
      <div
        class="left_img"
        v-if="NewsItemData && NewsItemData.pics && NewsItemData.pics.length > 0"
      >
        <div
          class="img_flag img_flag_recommond"
          v-if="specialTagName == '推荐'"
        >
          推荐
        </div>
        <div class="img_flag img_flag_new" v-else-if="specialTagName == '最新'">
          最新
        </div>
        <img
          :src="
            NewsItemData && NewsItemData.pics && NewsItemData.pics[0].url
              ? NewsItemData.pics[0].url
              : '#'
          "
          alt="新闻图片"
        />
      </div>
      <div class="right_content">
        <div
          class="right_content_title"
          :style="specialTagName == '推荐' ? 'color:#1981FF' : ''"
        >
          {{ NewsItemData.title }}
        </div>
        <div class="right_content_subtitle">
          {{ NewsItemData.desc }}
        </div>
        <div class="right_content_operations">
          <div class="operations_common operations_date">
            <div class="operations_common_icon"></div>
            <div class="operations_common_num">
              {{ NewsItemData.update_time | yearForm }}年{{
                NewsItemData.update_time | monthForm
              }}月{{ NewsItemData.update_time | dayForm }}日
            </div>
          </div>
          <div class="operations_common operations_seenum">
            <div class="operations_common_icon"></div>
            <div class="operations_common_num">
              {{ NewsItemData.views_count }}
            </div>
          </div>
          <div class="operations_common operations_hotnum">
            <div class="operations_common_icon"></div>
            <div class="operations_common_num">
              {{ NewsItemData.views_count }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NewsListItem",
  data() {
    return {};
  },
  props: {
    specialTagName: {
      //左上角显示   "最新" 、"推荐"、""
      default: "",
    },
    NewsItemData: {
      //数据详情
      default: [],
    },
  },
};
</script>
<style scoped lang="scss">
.container_wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 146px;
  padding-right: 25px;
  padding-bottom: 17px;
  border-bottom: 1px solid #f4f4f4;
  margin-top: 20px;
  //width: 835px;
  &:hover {
    transform: scale(1.01);
    cursor: pointer;
  }
  .left_img,
  img {
    max-height: 146px;
    width: 217px;
    border-radius: 4px;
  }
  .left_img {
    position: relative;
    margin-right: 19px;
    .img_flag {
      position: absolute;
      top: -4px;
      left: 0;
      text-align: center;
      line-height: 34px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .img_flag_recommond {
      width: 77px;
      height: 34px;
      left: 0;
      background: url("~@/assets/images/mainindex/icon-news-list@2x.png")
        no-repeat;
      background-size: 100% 100%;
    }
    .img_flag_new {
      width: 57px;
      height: 25px;
      background: url("~@/assets/images/mainindex/编组 14@2x.png") no-repeat;
      background-size: 100% 100%;
      left: 11px;
      line-height: 25px;
    }
  }
  .right_content {
    flex: 1;
    height: 146px;
    position: relative;
    overflow: hidden;
    .right_content_title {
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 25px;
      box-sizing: border-box;
      overflow: hidden;
      // word-wrap: break-word;
      // word-break: normal;
      // overflow: hidden;
      // text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .right_content_subtitle {
      width: 100%;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #777777;
      line-height: 20px;
      margin-top: 9px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
    }
    .right_content_operations {
      position: absolute;
      width: 100%;
      right: 0;
      bottom: 0;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      .operations_common {
        display: flex;
        flex-direction: row;
        .operations_common_icon {
          display: inline-block;
          margin-right: 4px;
          margin-top: 2px;
          width: 18px;
          height: 16px;
          background: url("~@/assets/images/mainindex/icon-news-list-time@2x.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
      .operations_date {
        margin-right: 34px;
      }
      .operations_seenum {
        margin-right: 29px;
        .operations_common_icon {
          width: 16px;
          height: 14px;
          background: url("~@/assets/images/mainindex/icon-news-list- author@2x.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
      .operations_hotnum {
        .operations_common_icon {
          width: 13px;
          height: 16px;
          background: url("~@/assets/images/mainindex/icon-news-list-hot@2x.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// NewsListItem2.vue?8a09860e